export function buildStudentLessonPath({ lessonId = '' } = {}) {
  if (!lessonId) {
    return '/lessons';
  }

  return `/lessons/${lessonId}`;
}

